import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

import { observable, runInAction, computed, makeObservable, action } from "mobx";
import { insertDelimiters, isItemExcludedFromDigitalCheck, isModifierHasPrefix, roundTo } from "@dp/common";
import { CheckTypes } from "@dp/services";
import { InputAction } from "@dp/common";
import moment from "moment-timezone";
var CheckModel = (_class = /*#__PURE__*/function () {
  function CheckModel() {
    _classCallCheck(this, CheckModel);

    _initializerDefineProperty(this, "_paymentCode", _descriptor, this);

    _initializerDefineProperty(this, "_errorMessage", _descriptor2, this);

    _initializerDefineProperty(this, "_order", _descriptor3, this);

    _initializerDefineProperty(this, "_isCallin", _descriptor4, this);

    _initializerDefineProperty(this, "_callInErrorObj", _descriptor5, this);

    _initializerDefineProperty(this, "_showHowMobilePayWorksModal", _descriptor6, this);

    _initializerDefineProperty(this, "_dialogueCode", _descriptor7, this);

    makeObservable(this);
  }

  _createClass(CheckModel, [{
    key: "handleInvalidModel",
    value: function handleInvalidModel() {// TODO
    }
  }, {
    key: "clearPaymentErrors",
    value: function clearPaymentErrors() {
      var _this$order;

      if ((_this$order = this.order) !== null && _this$order !== void 0 && _this$order.paymentErrors) {
        delete this.order.paymentErrors;
      }
    }
  }, {
    key: "resetValues",
    value: function resetValues() {
      this._paymentCode = "";
      this._errorMessage = "";
      this._order = null;
      this._dialogueCode = null;
    }
  }, {
    key: "processCheckDetailItems",
    value: function processCheckDetailItems(orderLineItems) {
      var _orderLineItems$adjus,
          _orderLineItems$adjus2,
          _orderLineItems$adjus3,
          _orderLineItems$adjus4,
          _orderLineItems$adjus5,
          _orderLineItems$adjus6,
          _orderLineItems$modif,
          _this = this;

      var checkItems = {}; // check to whether the item needs to be inserted in the calling function array or not

      if (isItemExcludedFromDigitalCheck(orderLineItems.menuItemName) || !!orderLineItems.voidItem) {
        checkItems.itemPrice = null;
        return checkItems;
      }

      checkItems.itemName = orderLineItems.menuItemName;
      checkItems.isDiscounted = orderLineItems.adjustments !== null;
      checkItems.itemPrice = orderLineItems.unitPrice.value;
      checkItems.quantity = orderLineItems.quantity;
      checkItems.discountLabel = (_orderLineItems$adjus = orderLineItems.adjustments) === null || _orderLineItems$adjus === void 0 ? void 0 : (_orderLineItems$adjus2 = _orderLineItems$adjus.adjustment) === null || _orderLineItems$adjus2 === void 0 ? void 0 : (_orderLineItems$adjus3 = _orderLineItems$adjus2[0]) === null || _orderLineItems$adjus3 === void 0 ? void 0 : _orderLineItems$adjus3.name;
      checkItems.discountPrice = (_orderLineItems$adjus4 = orderLineItems.adjustments) === null || _orderLineItems$adjus4 === void 0 ? void 0 : (_orderLineItems$adjus5 = _orderLineItems$adjus4.adjustment) === null || _orderLineItems$adjus5 === void 0 ? void 0 : (_orderLineItems$adjus6 = _orderLineItems$adjus5[0]) === null || _orderLineItems$adjus6 === void 0 ? void 0 : _orderLineItems$adjus6.amount.value;
      checkItems.modifiers = [];
      checkItems.modifiersCost = 0;
      checkItems.modifiersDiscount = 0;
      var skipNextItem = false;
      (_orderLineItems$modif = orderLineItems.modifiers) === null || _orderLineItems$modif === void 0 ? void 0 : _orderLineItems$modif.orderLineItem.forEach(function (modifierOrderItem, index) {
        var _modifierItemData$mod;

        var modifierItemData = _this.processCheckDetailItems(modifierOrderItem);

        var itemName = modifierItemData.itemName;

        if (skipNextItem) {
          skipNextItem = false;
          return;
        }

        if (isModifierHasPrefix(itemName)) {
          var _orderLineItems$modif2, _orderLineItems$modif3;

          itemName = itemName + " " + ((_orderLineItems$modif2 = orderLineItems.modifiers) === null || _orderLineItems$modif2 === void 0 ? void 0 : (_orderLineItems$modif3 = _orderLineItems$modif2.orderLineItem[index + 1]) === null || _orderLineItems$modif3 === void 0 ? void 0 : _orderLineItems$modif3.menuItemName);
          skipNextItem = true;
        }

        checkItems.modifiers.push({
          itemName: itemName.replace("+", "-"),
          itemPrice: modifierItemData.itemPrice,
          quantity: modifierItemData.quantity,
          isDiscounted: modifierItemData.isDiscounted,
          discountLabel: modifierItemData.discountLabel,
          discountPrice: modifierItemData.discountPrice
        });
        checkItems.modifiersCost += modifierItemData.modifiersCost + modifierItemData.itemPrice;
        checkItems.modifiersCost = roundTo(checkItems.modifiersCost, 2);
        checkItems.modifiersDiscount = roundTo(checkItems.modifiersDiscount + modifierItemData.discountPrice + modifierItemData.modifiersDiscount, 2);
        (_modifierItemData$mod = modifierItemData.modifiers) === null || _modifierItemData$mod === void 0 ? void 0 : _modifierItemData$mod.forEach(function (modifierSubItem) {
          checkItems.modifiers.push(modifierSubItem);
        });
      });
      return checkItems;
    }
  }, {
    key: "paymentCode",
    get: function get() {
      return this._paymentCode;
    },
    set: function set(val) {
      var _this2 = this;

      runInAction(function () {
        _this2._paymentCode = val;
      });

      if (this._paymentCode) {
        this.isCallin = !!(this._paymentCode.length > 16);
      }

      if (val) {
        var existing = this._paymentCode;
        var addDeleteAction = existing && val.length <= existing.length ? InputAction.DELETE : InputAction.ADD;
        var gaps = val.length > 3 ? [3, 6, 9] : null;
        var formattedPaymentCode = insertDelimiters(val, gaps, "-", addDeleteAction);
        var cNum = formattedPaymentCode ? formattedPaymentCode.split("-").join("") : "";
        var isNumber = /^\d+$/.test(cNum);

        if (isNumber) {
          runInAction(function () {
            _this2._paymentCode = formattedPaymentCode;
          });
        }
      }
    }
  }, {
    key: "isValid",
    get: function get() {
      return !!this._paymentCode && this._paymentCode.length > 12 && !this.errorMessage;
    }
  }, {
    key: "isCallin",
    get: function get() {
      return this._isCallin;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._isCallin = val;
      });
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._errorMessage = val;
      });
    }
  }, {
    key: "dashCheckId",
    get: function get() {
      var _this$order2, _this$order2$order, _this$order2$order$or;

      var orderIds = (_this$order2 = this.order) === null || _this$order2 === void 0 ? void 0 : (_this$order2$order = _this$order2.order) === null || _this$order2$order === void 0 ? void 0 : (_this$order2$order$or = _this$order2$order.orderIDs) === null || _this$order2$order$or === void 0 ? void 0 : _this$order2$order$or.orderID;
      return orderIds && orderIds.length ? orderIds[0].ID : null;
    }
  }, {
    key: "dashCheckNumber",
    get: function get() {
      var _this$order$checkNumb, _this$order3, _this$order4, _this$order4$order;

      return (_this$order$checkNumb = (_this$order3 = this.order) === null || _this$order3 === void 0 ? void 0 : _this$order3.checkNumber) !== null && _this$order$checkNumb !== void 0 ? _this$order$checkNumb : (_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : (_this$order4$order = _this$order4.order) === null || _this$order4$order === void 0 ? void 0 : _this$order4$order.checkNumber;
    }
  }, {
    key: "dashTableNumber",
    get: function get() {
      var _this$order5;

      return (_this$order5 = this.order) === null || _this$order5 === void 0 ? void 0 : _this$order5.tableNumber;
    }
  }, {
    key: "mpTransactionID",
    get: function get() {
      var _this$order6;

      return (_this$order6 = this.order) === null || _this$order6 === void 0 ? void 0 : _this$order6.transactionId;
    }
  }, {
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._order = val;
      });
    }
  }, {
    key: "containsPreAppliedPayments",
    get: function get() {
      var preAppliedPaymentsCount = this.preAppliedPayments.payments.length;
      return !!preAppliedPaymentsCount;
    }
  }, {
    key: "preAppliedCreditCardPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "CREDIT_CARD";
      });
    }
  }, {
    key: "preAppliedGiftCardPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "GIFT_CARD";
      });
    }
  }, {
    key: "preAppliedOtherPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "OTHER";
      });
    }
  }, {
    key: "preAppliedGooglePayPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "GOOGLEPAY";
      });
    }
  }, {
    key: "preAppliedApplePayPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "APPLEPAY";
      });
    }
  }, {
    key: "preAppliedPayPalPayments",
    get: function get() {
      return this.preAppliedPayments.payments.filter(function (payment) {
        return payment.type === "PAYPAL";
      });
    }
  }, {
    key: "remainingTippableAmount",
    get: function get() {
      var _this$order7, _this$order7$order, _this$order7$order$ti;

      var tippableAmount = (_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : (_this$order7$order = _this$order7.order) === null || _this$order7$order === void 0 ? void 0 : (_this$order7$order$ti = _this$order7$order.tippableAmount) === null || _this$order7$order$ti === void 0 ? void 0 : _this$order7$order$ti.value;
      var remainingTippableAmount = this.preAppliedPayments.payments.reduce(function (acc, payment) {
        var paymentTipVal = payment.tipAmount || 0.0;
        var amount = payment.amount || 0.0;

        if (paymentTipVal) {
          acc = acc - amount;
        }

        return acc;
      }, tippableAmount);
      return remainingTippableAmount > 0 ? remainingTippableAmount : 0;
    }
  }, {
    key: "preAppliedPayments",
    get: function get() {
      var _this$order8, _this$order8$order, _this$order8$order$pa;

      var paymentItems = (_this$order8 = this.order) === null || _this$order8 === void 0 ? void 0 : (_this$order8$order = _this$order8.order) === null || _this$order8$order === void 0 ? void 0 : (_this$order8$order$pa = _this$order8$order.paymentItems) === null || _this$order8$order$pa === void 0 ? void 0 : _this$order8$order$pa.paymentItem;
      return paymentItems ? paymentItems.reduce(function (acc, itm) {
        var _itm$paymentAccount, _itm$paymentAccount2;

        var creditCard = (_itm$paymentAccount = itm.paymentAccount) === null || _itm$paymentAccount === void 0 ? void 0 : _itm$paymentAccount.creditCard;
        var giftCard = (_itm$paymentAccount2 = itm.paymentAccount) === null || _itm$paymentAccount2 === void 0 ? void 0 : _itm$paymentAccount2.giftCard;
        var googlePay = (itm === null || itm === void 0 ? void 0 : itm.paymentClassification) === "GOOGLEPAY" ? "GOOGLEPAY" : null;
        var applePay = (itm === null || itm === void 0 ? void 0 : itm.paymentClassification) === "APPLEPAY" ? "APPLEPAY" : null;
        var payPal = (itm === null || itm === void 0 ? void 0 : itm.paymentClassification) === "PAYPAL" ? "PAYPAL" : null;

        if (creditCard || giftCard || googlePay || applePay || payPal) {
          if (creditCard) {
            var _creditCard$token, _itm$amount, _itm$amount2, _creditCard$token2, _itm$tipAmount, _itm$tipAmount2, _itm$amount3;

            var tokenNumber = creditCard === null || creditCard === void 0 ? void 0 : (_creditCard$token = creditCard.token) === null || _creditCard$token === void 0 ? void 0 : _creditCard$token.value;
            var last4 = tokenNumber ? tokenNumber.substring(tokenNumber.length - 4, tokenNumber.length) : tokenNumber;
            acc.payments.push({
              type: "CREDIT_CARD",
              amount: (_itm$amount = itm.amount) === null || _itm$amount === void 0 ? void 0 : _itm$amount.value,
              authorizationAmount: (_itm$amount2 = itm.amount) === null || _itm$amount2 === void 0 ? void 0 : _itm$amount2.value,
              authorizationDate: itm.authorizationDate,
              cardName: creditCard === null || creditCard === void 0 ? void 0 : creditCard.cardName,
              cardNumber: last4,
              token: creditCard === null || creditCard === void 0 ? void 0 : (_creditCard$token2 = creditCard.token) === null || _creditCard$token2 === void 0 ? void 0 : _creditCard$token2.value,
              tipAmount: (_itm$tipAmount = itm.tipAmount) === null || _itm$tipAmount === void 0 ? void 0 : _itm$tipAmount.value
            });

            if ((_itm$tipAmount2 = itm.tipAmount) !== null && _itm$tipAmount2 !== void 0 && _itm$tipAmount2.value) {
              acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
            }

            if ((_itm$amount3 = itm.amount) !== null && _itm$amount3 !== void 0 && _itm$amount3.value) {
              acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
            }
          }

          if (giftCard) {
            var _itm$amount4, _itm$amount5, _giftCard$availableBa, _giftCard$token, _itm$tipAmount3, _itm$tipAmount4, _itm$amount6;

            acc.payments.push({
              type: "GIFT_CARD",
              amount: (_itm$amount4 = itm.amount) === null || _itm$amount4 === void 0 ? void 0 : _itm$amount4.value,
              authorizationAmount: (_itm$amount5 = itm.amount) === null || _itm$amount5 === void 0 ? void 0 : _itm$amount5.value,
              authorizationDate: itm.authorizationDate,
              cardName: giftCard === null || giftCard === void 0 ? void 0 : giftCard.cardName,
              cardNumber: giftCard === null || giftCard === void 0 ? void 0 : giftCard.cardNumber,
              availableBalance: giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$availableBa = giftCard.availableBalance) === null || _giftCard$availableBa === void 0 ? void 0 : _giftCard$availableBa.value,
              token: giftCard === null || giftCard === void 0 ? void 0 : (_giftCard$token = giftCard.token) === null || _giftCard$token === void 0 ? void 0 : _giftCard$token.value,
              tipAmount: (_itm$tipAmount3 = itm.tipAmount) === null || _itm$tipAmount3 === void 0 ? void 0 : _itm$tipAmount3.value
            });

            if ((_itm$tipAmount4 = itm.tipAmount) !== null && _itm$tipAmount4 !== void 0 && _itm$tipAmount4.value) {
              acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
            }

            if ((_itm$amount6 = itm.amount) !== null && _itm$amount6 !== void 0 && _itm$amount6.value) {
              acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
            }
          }

          if (googlePay) {
            var _itm$amount7, _itm$amount8, _itm$tipAmount5, _itm$tipAmount6, _itm$amount9;

            acc.payments.push({
              type: "GOOGLEPAY",
              amount: (_itm$amount7 = itm.amount) === null || _itm$amount7 === void 0 ? void 0 : _itm$amount7.value,
              authorizationAmount: (_itm$amount8 = itm.amount) === null || _itm$amount8 === void 0 ? void 0 : _itm$amount8.value,
              tipAmount: (_itm$tipAmount5 = itm.tipAmount) === null || _itm$tipAmount5 === void 0 ? void 0 : _itm$tipAmount5.value
            });

            if ((_itm$tipAmount6 = itm.tipAmount) !== null && _itm$tipAmount6 !== void 0 && _itm$tipAmount6.value) {
              acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
            }

            if ((_itm$amount9 = itm.amount) !== null && _itm$amount9 !== void 0 && _itm$amount9.value) {
              acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
            }
          }

          if (applePay) {
            var _itm$amount10, _itm$amount11, _itm$tipAmount7, _itm$tipAmount8, _itm$amount12;

            acc.payments.push({
              type: "APPLEPAY",
              amount: (_itm$amount10 = itm.amount) === null || _itm$amount10 === void 0 ? void 0 : _itm$amount10.value,
              authorizationAmount: (_itm$amount11 = itm.amount) === null || _itm$amount11 === void 0 ? void 0 : _itm$amount11.value,
              tipAmount: (_itm$tipAmount7 = itm.tipAmount) === null || _itm$tipAmount7 === void 0 ? void 0 : _itm$tipAmount7.value
            });

            if ((_itm$tipAmount8 = itm.tipAmount) !== null && _itm$tipAmount8 !== void 0 && _itm$tipAmount8.value) {
              acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
            }

            if ((_itm$amount12 = itm.amount) !== null && _itm$amount12 !== void 0 && _itm$amount12.value) {
              acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
            }
          }

          if (payPal) {
            var _itm$amount13, _itm$amount14, _itm$tipAmount9, _itm$tipAmount10, _itm$amount15;

            acc.payments.push({
              type: "PAYPAL",
              amount: (_itm$amount13 = itm.amount) === null || _itm$amount13 === void 0 ? void 0 : _itm$amount13.value,
              authorizationAmount: (_itm$amount14 = itm.amount) === null || _itm$amount14 === void 0 ? void 0 : _itm$amount14.value,
              tipAmount: (_itm$tipAmount9 = itm.tipAmount) === null || _itm$tipAmount9 === void 0 ? void 0 : _itm$tipAmount9.value
            });

            if ((_itm$tipAmount10 = itm.tipAmount) !== null && _itm$tipAmount10 !== void 0 && _itm$tipAmount10.value) {
              acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
            }

            if ((_itm$amount15 = itm.amount) !== null && _itm$amount15 !== void 0 && _itm$amount15.value) {
              acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
            }
          }
        } else {
          var _itm$amount16, _itm$tipAmount11, _itm$tipAmount12, _itm$amount17; //neither


          acc.payments.push({
            type: "OTHER",
            amount: (_itm$amount16 = itm.amount) === null || _itm$amount16 === void 0 ? void 0 : _itm$amount16.value,
            tipAmount: (_itm$tipAmount11 = itm.tipAmount) === null || _itm$tipAmount11 === void 0 ? void 0 : _itm$tipAmount11.value
          });

          if ((_itm$tipAmount12 = itm.tipAmount) !== null && _itm$tipAmount12 !== void 0 && _itm$tipAmount12.value) {
            acc.cumulativeTip = acc.cumulativeTip + itm.tipAmount.value;
          }

          if ((_itm$amount17 = itm.amount) !== null && _itm$amount17 !== void 0 && _itm$amount17.value) {
            acc.cumulativeAmount = acc.cumulativeAmount + itm.amount.value;
          }
        }

        return acc;
      }, {
        payments: [],
        cumulativeTip: 0,
        cumulativeAmount: 0
      }) : {
        payments: [],
        cumulativeTip: 0,
        cumulativeAmount: 0
      };
    }
  }, {
    key: "showPaymentErrors",
    get: function get() {
      var _this$order9;

      var paymentErrors = (_this$order9 = this.order) === null || _this$order9 === void 0 ? void 0 : _this$order9.paymentErrors;
      return paymentErrors && paymentErrors.length > 0;
    }
  }, {
    key: "containsSessionExpiredPaymentError",
    get: function get() {
      var _this$order10;

      var paymentErrors = (_this$order10 = this.order) === null || _this$order10 === void 0 ? void 0 : _this$order10.paymentErrors;

      if (paymentErrors) {
        return paymentErrors.reduce(function (res, paymentError) {
          if (paymentError.reasonCode === "AUTH_FAILED" && paymentError.reasonDescription === "CONSUMER_DETAILS_NOT_FOUND") {
            res = true;
          }

          return res;
        }, false);
      } else {
        return false;
      }
    }
  }, {
    key: "containsPartialPayment",
    get: function get() {
      var _orderCheckDetails$or, _orderCheckDetails$or2, _orderCheckDetails$or3;

      var validatePaymentfailure = false;
      var orderCheckDetails = this.order;
      var paymentErrors = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : orderCheckDetails.paymentErrors;
      var paymentItems = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : (_orderCheckDetails$or = orderCheckDetails.order) === null || _orderCheckDetails$or === void 0 ? void 0 : _orderCheckDetails$or.paymentItems;
      var checkBalance = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : (_orderCheckDetails$or2 = orderCheckDetails.order) === null || _orderCheckDetails$or2 === void 0 ? void 0 : (_orderCheckDetails$or3 = _orderCheckDetails$or2.balance) === null || _orderCheckDetails$or3 === void 0 ? void 0 : _orderCheckDetails$or3.value;

      if (checkBalance && checkBalance > 0) {
        var _paymentItems$payment;

        validatePaymentfailure = paymentItems && (paymentItems === null || paymentItems === void 0 ? void 0 : paymentItems.paymentItem) && (paymentItems === null || paymentItems === void 0 ? void 0 : (_paymentItems$payment = paymentItems.paymentItem) === null || _paymentItems$payment === void 0 ? void 0 : _paymentItems$payment.length) > 0 && paymentErrors && (paymentErrors === null || paymentErrors === void 0 ? void 0 : paymentErrors.length) === 0;
      }

      return validatePaymentfailure;
    }
  }, {
    key: "generalPaymentFailure",
    get: function get() {
      var _orderCheckDetails$or4, _orderCheckDetails$or5, _orderCheckDetails$or6;

      var validatePaymentfailure = false;
      var orderCheckDetails = this.order;
      var paymentErrors = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : orderCheckDetails.paymentErrors;
      var paymentItems = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : (_orderCheckDetails$or4 = orderCheckDetails.order) === null || _orderCheckDetails$or4 === void 0 ? void 0 : _orderCheckDetails$or4.paymentItems;
      var checkBalance = orderCheckDetails === null || orderCheckDetails === void 0 ? void 0 : (_orderCheckDetails$or5 = orderCheckDetails.order) === null || _orderCheckDetails$or5 === void 0 ? void 0 : (_orderCheckDetails$or6 = _orderCheckDetails$or5.balance) === null || _orderCheckDetails$or6 === void 0 ? void 0 : _orderCheckDetails$or6.value;

      if (checkBalance && checkBalance > 0 && !paymentItems) {
        validatePaymentfailure = paymentErrors && (paymentErrors === null || paymentErrors === void 0 ? void 0 : paymentErrors.length) === 0;
      }

      return validatePaymentfailure;
    }
  }, {
    key: "subtotalOnPrintedCheck",
    get: function get() {
      var _this$order11, _this$order12;

      var subTotal = (_this$order11 = this.order) === null || _this$order11 === void 0 ? void 0 : _this$order11.order.subTotal.value;
      var preAppliedCouponDiscount = (_this$order12 = this.order) === null || _this$order12 === void 0 ? void 0 : _this$order12.couponDiscount;
      return subTotal - (preAppliedCouponDiscount || 0.0);
    }
  }, {
    key: "creditCardPaymentErrors",
    get: function get() {
      var _this$order13;

      if ((_this$order13 = this.order) !== null && _this$order13 !== void 0 && _this$order13.paymentErrors) {
        return this.order.paymentErrors.filter(function (paymentErr) {
          return paymentErr.paymentMethod === CheckTypes.PaymentMethod.CREDIT_CARD;
        });
      } else {
        return [];
      }
    }
  }, {
    key: "containsPreAppliedCoupons",
    get: function get() {
      var _this$order14;

      var preAppliedCouponDiscount = (_this$order14 = this.order) === null || _this$order14 === void 0 ? void 0 : _this$order14.couponDiscount;
      return preAppliedCouponDiscount > 0;
    }
  }, {
    key: "giftCardPaymentErrors",
    get: function get() {
      var _this$order15;

      if ((_this$order15 = this.order) !== null && _this$order15 !== void 0 && _this$order15.paymentErrors) {
        return this.order.paymentErrors.filter(function (paymentErr) {
          return paymentErr.paymentMethod === CheckTypes.PaymentMethod.GIFT_CARD;
        });
      } else {
        return [];
      }
    }
  }, {
    key: "callInError",
    get: function get() {
      return this._callInErrorObj;
    },
    set: function set(val) {
      var _this6 = this;

      runInAction(function () {
        _this6._callInErrorObj = val;
      });
    }
  }, {
    key: "showHowMobilePayWorksModal",
    get: function get() {
      return this._showHowMobilePayWorksModal;
    },
    set: function set(state) {
      var _this7 = this;

      runInAction(function () {
        _this7._showHowMobilePayWorksModal = state;
      });
    }
  }, {
    key: "checkDetails",
    get: function get() {
      var _this8 = this;

      var checkDetails = {};
      var orderSuccessResponse = this._order;
      var order = orderSuccessResponse === null || orderSuccessResponse === void 0 ? void 0 : orderSuccessResponse.order;

      if (Object.keys(order).length > 0) {
        var _order$employee, _order$employee$name, _order$orderItems$ord, _order$orderItems$ord2; // TODO: managingPartnerName needs to be updated once the Data starts coming in the API


        checkDetails.managingPartnerName = order["managingPartnerName"];
        checkDetails.serverName = (_order$employee = order.employee) === null || _order$employee === void 0 ? void 0 : (_order$employee$name = _order$employee.name) === null || _order$employee$name === void 0 ? void 0 : _order$employee$name.nickName;
        checkDetails.checkRestaurantNumber = orderSuccessResponse.restNumber;
        checkDetails.checkNumber = order.checkNumber;
        checkDetails.checkCreationDate = moment(order.createDate).format("MM/DD/YYYY");
        checkDetails.checkCreationTime = moment(order.createDate).format("h:mm A");
        checkDetails.checkLevelDiscount = orderSuccessResponse.couponDiscount;
        var orderLineItem = (_order$orderItems$ord = order.orderItems.orderItem[0]) === null || _order$orderItems$ord === void 0 ? void 0 : (_order$orderItems$ord2 = _order$orderItems$ord.orderLineItems) === null || _order$orderItems$ord2 === void 0 ? void 0 : _order$orderItems$ord2.orderLineItem;
        checkDetails.checkItems = [];
        orderLineItem.forEach(function (orderItem, orderItemIdx) {
          var checkDetailsItems = _this8.processCheckDetailItems(orderItem);

          if (checkDetailsItems.itemPrice !== null) {
            checkDetails.checkItems.push(checkDetailsItems);
          }
        }); // Not in current scope
        // checkDetails.checkItems.sort((itemOne, itemTwo) => {
        //   const unitPriceOfItemOne = Number(
        //     Number(itemOne.itemPrice) / Number(itemOne.quantity),
        //   );
        //   const unitPriceOfItemTwo = Number(
        //     Number(itemTwo.itemPrice) / Number(itemTwo.quantity),
        //   );
        //   return unitPriceOfItemOne - unitPriceOfItemTwo;
        // });
      }

      return checkDetails;
    }
  }, {
    key: "dialogueCode",
    get: function get() {
      return this._dialogueCode;
    },
    set: function set(_dialogueCode) {
      var _this9 = this;

      runInAction(function () {
        _this9._dialogueCode = _dialogueCode;
      });
    }
  }]);

  return CheckModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_paymentCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_errorMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_order", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isCallin", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_callInErrorObj", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_showHowMobilePayWorksModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_dialogueCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "paymentCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "paymentCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCallin", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCallin"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dashCheckId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dashCheckId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dashCheckNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dashCheckNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dashTableNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dashTableNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mpTransactionID", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mpTransactionID"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "order", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "order"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "containsPreAppliedPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "containsPreAppliedPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedCreditCardPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedCreditCardPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedGiftCardPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedGiftCardPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedOtherPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedOtherPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedGooglePayPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedGooglePayPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedApplePayPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedApplePayPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedPayPalPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedPayPalPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingTippableAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "remainingTippableAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preAppliedPayments", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "preAppliedPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPaymentErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPaymentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "containsSessionExpiredPaymentError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "containsSessionExpiredPaymentError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "containsPartialPayment", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "containsPartialPayment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "generalPaymentFailure", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "generalPaymentFailure"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearPaymentErrors", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearPaymentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subtotalOnPrintedCheck", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subtotalOnPrintedCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "creditCardPaymentErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "creditCardPaymentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "containsPreAppliedCoupons", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "containsPreAppliedCoupons"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "giftCardPaymentErrors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "giftCardPaymentErrors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetValues", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resetValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "callInError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "callInError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHowMobilePayWorksModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showHowMobilePayWorksModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dialogueCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dialogueCode"), _class.prototype)), _class);
export { CheckModel as default };